module.exports = __webpack_public_path__ + "img/loading-dots.80b5d783.gif";